package com.evoapps.evoshift.ui.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import com.evoapps.evoshift.domain.legal.ClosureReason
import com.evoapps.evoshift.domain.legal.DayClosure
import com.evoapps.evoshift.domain.model.SundayPolicy
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.day_closed_holiday
import evoshift.composeapp.generated.resources.day_closed_non_trading_sunday
import evoshift.composeapp.generated.resources.day_closed_sunday
import evoshift.composeapp.generated.resources.settings_sunday_closed_desc
import evoshift.composeapp.generated.resources.settings_sunday_closed_title
import evoshift.composeapp.generated.resources.settings_sunday_open_desc
import evoshift.composeapp.generated.resources.settings_sunday_open_title
import evoshift.composeapp.generated.resources.settings_sunday_trading_desc
import evoshift.composeapp.generated.resources.settings_sunday_trading_title
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

/** "Closed (non-trading Sunday)", "Closed (public holiday)" or "Closed (Sunday)" (SH-55). */
fun closureLabelRes(reason: ClosureReason): StringResource = when (reason) {
    ClosureReason.NON_TRADING_SUNDAY -> Res.string.day_closed_non_trading_sunday
    ClosureReason.PUBLIC_HOLIDAY -> Res.string.day_closed_holiday
    ClosureReason.SUNDAY -> Res.string.day_closed_sunday
}

@Composable
fun closureLabel(closure: DayClosure): String = stringResource(closureLabelRes(closure.reason))

fun sundayPolicyTitleRes(policy: SundayPolicy): StringResource = when (policy) {
    SundayPolicy.OPEN -> Res.string.settings_sunday_open_title
    SundayPolicy.TRADING_SUNDAYS -> Res.string.settings_sunday_trading_title
    SundayPolicy.CLOSED -> Res.string.settings_sunday_closed_title
}

fun sundayPolicyDescriptionRes(policy: SundayPolicy): StringResource = when (policy) {
    SundayPolicy.OPEN -> Res.string.settings_sunday_open_desc
    SundayPolicy.TRADING_SUNDAYS -> Res.string.settings_sunday_trading_desc
    SundayPolicy.CLOSED -> Res.string.settings_sunday_closed_desc
}

/**
 * The days of the shown month the workplace's Sunday policy closes, by ISO date (SH-55): the daily
 * results' cards, rows and carousel read it instead of passing it through every composable.
 */
val LocalDayClosures = staticCompositionLocalOf<Map<String, DayClosure>> { emptyMap() }
